module.exports = __webpack_public_path__ + "img/frame (282).67067418.jpg";